"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var pay_api_1 = require("@l2p/pay-api");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var image_1 = __importDefault(require("next/image"));
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var STATUSES = {
    success: 'success',
    error: 'error',
    cancel: 'cancel',
    pending: 'pending',
};
var DepositStatus = function (_a) {
    var _b, _c, _d;
    var status = _a.status, supportEmail = _a.supportEmail;
    var t = (0, next_intl_1.useTranslations)('translation');
    var tDep = (0, next_intl_1.useTranslations)('depositStatuses');
    var closeModal = (0, apps_shared_1.useCloseModal)(true);
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var openHomePage = (0, apps_shared_1.useOpenHomePage)();
    var _e = (0, swr_hooks_1.useTransactions)(pay_api_1.TransactionTypeEnum.Deposit), data = _e.data, isLoading = _e.isLoading;
    var acceptedTransactions = (_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.transaction) === null || _b === void 0 ? void 0 : _b.get) === null || _c === void 0 ? void 0 : _c.edges) === null || _d === void 0 ? void 0 : _d.filter(function (t) { return t.status === pay_api_1.TransactionStatusEnum.Accepted; });
    var lastAcceptedTransaction = acceptedTransactions
        ? acceptedTransactions[0]
        : null;
    var description = (0, react_1.useMemo)(function () {
        if (status === STATUSES.pending)
            return (react_1.default.createElement("div", null,
                react_1.default.createElement("p", null,
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.pendingDescription }, tDep('pendingLine1'))),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("a", { className: styles_module_scss_1.default.supportLink, href: "mailto:".concat(supportEmail) }, supportEmail)),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.pendingDescription }, tDep('pendingLine2'))),
                react_1.default.createElement("br", null),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.pendingDescription }, tDep('pendingLine3')))));
        return (react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                __html: t.raw("".concat(status, "DepositStatusMessage")),
            } }));
    }, [supportEmail, t, tDep, status]);
    if (status === STATUSES.success && isLoading) {
        return react_1.default.createElement(ui_components_1.LoadingSpinner, null);
    }
    return (react_1.default.createElement(ui_components_1.Modal, { width: "600px", height: "auto", padding: "0", saveSize: true },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.icon },
                    react_1.default.createElement(image_1.default, { src: "/img/depositStatuses/".concat(status, ".svg"), width: 40, height: 40, alt: status })),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t("".concat(status, "DepositStatusTitle"))),
                status === STATUSES.success && lastAcceptedTransaction && (react_1.default.createElement("div", { className: styles_module_scss_1.default.funds },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.fundsText }, t('successDepositStatusMessage')),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.fundsAmount },
                        (0, apps_shared_1.getCurrencySymbol)(lastAcceptedTransaction.currency),
                        lastAcceptedTransaction.amount))),
                status === STATUSES.error && (react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, t('errorDepositStatusMessage'))),
                status === STATUSES.pending && (react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, t('pendingDepositStatusMessage'))),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                    status === STATUSES.error && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", maxWidth: "320px", text: "upper", onClick: openDeposit }, t("errorDepositStatusButtonDeposit")),
                        react_1.default.createElement(ui_components_1.FixedButton, { color: "primary", variant: "outline", maxWidth: "320px", text: "upper", onClick: closeModal }, t("errorDepositStatusButtonClose")))),
                    status === STATUSES.success && (react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", maxWidth: "320px", text: "upper", onClick: closeModal }, t("successDepositStatusButton"))))))));
};
exports.default = DepositStatus;
